export default __webpack_public_path__ + "assets/4fda26b6f6139e90feb916c30a39c402.eot";